/**
 * Phone validation utilities supporting country-code-aware rules.
 */

export const PHONE_RULES_BY_CODE = {
    '+971': { min: 7, max: 10, label: '7 to 9-digit', country: 'UAE' },
    '+91':  { min: 10, max: 10, label: '10-digit', country: 'India' },
    '+1':   { min: 10, max: 10, label: '10-digit', country: 'USA/Canada' },
    '+44':  { min: 10, max: 11, label: '10 to 11-digit', country: 'UK' },
    '+61':  { min: 9, max: 10, label: '9 to 10-digit', country: 'Australia' },
    '+65':  { min: 8, max: 8, label: '8-digit', country: 'Singapore' },
    '+81':  { min: 9, max: 11, label: '9 to 11-digit', country: 'Japan' },
    '+49':  { min: 7, max: 11, label: '7 to 11-digit', country: 'Germany' },
    '+33':  { min: 9, max: 10, label: '9 to 10-digit', country: 'France' },
    '+86':  { min: 11, max: 11, label: '11-digit', country: 'China' },
};

export const SUPPORTED_PHONE_CODES = Object.keys(PHONE_RULES_BY_CODE);

/**
 * Validates phone digits against selected country code rules.
 * @param {string} phone 
 * @param {string} code 
 * @returns {string|null} Error message or null if valid
 */
export const validatePhoneByCode = (phone = '', code = '+91') => {
    const clean = (phone || '').replace(/\D/g, '');
    if (!clean) return 'Please enter a primary phone number.';
    
    const rule = PHONE_RULES_BY_CODE[code];
    if (rule) {
        if (rule.min === rule.max) {
            if (clean.length !== rule.min) {
                return `Please enter a valid ${rule.min}-digit phone number.`;
            }
        } else {
            if (clean.length < rule.min || clean.length > rule.max) {
                return `Please enter a valid ${rule.label} phone number.`;
            }
        }
    } else {
        if (clean.length < 7 || clean.length > 15) {
            return 'Please enter a valid phone number (7 to 15 digits).';
        }
    }
    return null;
};

/**
 * Get minimum phone length for a given country code or region.
 * @param {string} code 
 * @param {boolean} isUae 
 * @returns {number}
 */
export const getMinPhoneLength = (code = '', isUae = false) => {
    if (code === '+971' || isUae) return 7;
    const rule = PHONE_RULES_BY_CODE[code];
    return rule ? rule.min : (isUae ? 7 : 10);
};
